import { IframeMessageType } from '../types';

const CHILD_HEALTH_PROBE_START_DELAY_MS = 1000;
const CHILD_HEALTH_PROBE_INTERVAL_MS = 500;
const CHILD_HEALTH_PROBE_COUNT = 10;
const CHILD_HEARTBEAT_ALLOWED_PATH_PATTERNS = [/^\/plus\/match-centre\/[^/]+$/, /^\/plus\/match-center\/[^/]+$/];

let startupProbeTimeoutIds: number[] = [];

const isHeartbeatEnabledForCurrentPath = () =>
  CHILD_HEARTBEAT_ALLOWED_PATH_PATTERNS.some(pattern => pattern.test(window.location.pathname));

function getChildHealthContentHeight(): number {
  const mainElement = document.getElementById('main');
  const mainHeight = mainElement ? Math.round(mainElement.getBoundingClientRect().height) : 0;
  const rootHeight = Math.round(document.documentElement.scrollHeight || 0);

  return Math.max(mainHeight, rootHeight);
}

function sendIframeHealthHeartbeat() {
  if (!isHeartbeatEnabledForCurrentPath()) return;
  if (!window.parentIFrame?.sendMessage) return;

  const contentHeight = getChildHealthContentHeight();
  window.parentIFrame.sendMessage({
    type: IframeMessageType.IFRAME_HEALTH,
    data: { contentHeight, path: window.location.pathname },
  });
}

export function initChildHealthHeartbeat() {
  if (!isHeartbeatEnabledForCurrentPath()) return;
  startupProbeTimeoutIds.forEach(timeoutId => window.clearTimeout(timeoutId));
  startupProbeTimeoutIds = [];

  Array.from({ length: CHILD_HEALTH_PROBE_COUNT }, (_, index) => {
    return CHILD_HEALTH_PROBE_START_DELAY_MS + index * CHILD_HEALTH_PROBE_INTERVAL_MS;
  }).forEach(delayMs => {
    const timeoutId = window.setTimeout(() => {
      sendIframeHealthHeartbeat();
    }, delayMs);
    startupProbeTimeoutIds.push(timeoutId);
  });
}
